// extracted by mini-css-extract-plugin
module.exports = {"container":"RecommendedCardBodyDescription_container__94B2a","ean-text":"RecommendedCardBodyDescription_ean-text__9kz4c","name":"RecommendedCardBodyDescription_name__g88C0"};